/**
 * Default components factory and default settings
 */

export const defaultComponentOrder = [
  'header', 'hero', 'trust', 'authority', 'services', 'proofTable', 'process',
  'benefits', 'team', 'gallery', 'testimonials', 'faq', 'cta', 'stickyCta',
  'footer', 'cookie',
];

export function createDefaultComponents(): Record<string, any> {
  return {
    header: {
      id: 'header',
      type: 'header',
      name: 'Header',
      enabled: true,
      data: {
        logoText: 'BF',
        logoUrl: '',
        companyName: 'Firmenname',
        navItems: ['Leistungen', 'Methoden', '\u00dcber uns', 'Kontakt'],
        ctaText: 'Anfrage',
        showDarkModeToggle: false,
      },
    },
    hero: {
      id: 'hero',
      type: 'hero',
      name: 'Hero',
      enabled: true,
      data: {
        title: 'Headline die den Nutzen zeigt',
        subtitle:
          'Ein bis zwei S\u00e4tze die erkl\u00e4ren was Sie machen und warum der Besucher bei Ihnen richtig ist.',
        primaryBtn: 'Jetzt starten',
        secondaryBtn: 'Mehr erfahren',
        imageUrl: '',
      },
    },
    trust: {
      id: 'trust',
      type: 'trust',
      name: 'Trust Bar',
      enabled: true,
      data: {
        items: [
          { value: '500+', label: 'Kunden' },
          { value: '25+', label: 'Jahre Erfahrung' },
          { value: '98%', label: 'Zufriedenheit' },
        ],
      },
    },
    services: {
      id: 'services',
      type: 'services',
      name: 'Leistungen',
      enabled: true,
      data: {
        title: 'Unsere Leistungen',
        subtitle: 'Was wir f\u00fcr Sie tun k\u00f6nnen',
        items: [
          { icon: '\u{1F4CA}', title: 'Leistung 1', text: 'Beschreibung der ersten Leistung.' },
          { icon: '\u{1F4BC}', title: 'Leistung 2', text: 'Beschreibung der zweiten Leistung.' },
          { icon: '\u{1F3AF}', title: 'Leistung 3', text: 'Beschreibung der dritten Leistung.' },
        ],
      },
    },
    benefits: {
      id: 'benefits',
      type: 'benefits',
      name: 'Vorteile',
      enabled: true,
      data: {
        title: 'Warum wir?',
        items: [
          { title: 'Unabh\u00e4ngig', text: 'Wir beraten neutral und in Ihrem Interesse.' },
          { title: 'Pers\u00f6nlich', text: 'Ein fester Ansprechpartner f\u00fcr alle Fragen.' },
          { title: 'Erfahren', text: '\u00dcber 25 Jahre Branchenerfahrung.' },
        ],
      },
    },
    team: {
      id: 'team',
      type: 'team',
      name: 'Team',
      enabled: false,
      data: {
        title: 'Unser Team',
        subtitle: 'Die Menschen hinter dem Erfolg',
        members: [
          { name: 'Max Muster', role: 'Gesch\u00e4ftsf\u00fchrer', image: '', bio: 'Gr\u00fcnder mit 20 Jahren Erfahrung.' },
          { name: 'Anna Beispiel', role: 'Beraterin', image: '', bio: 'Spezialistin f\u00fcr Steuerfragen.' },
        ],
      },
    },
    gallery: {
      id: 'gallery',
      type: 'gallery',
      name: 'Galerie',
      enabled: false,
      data: {
        title: 'Einblicke',
        subtitle: 'Impressionen aus unserem Alltag',
        images: [
          { url: '', caption: 'Bild 1' },
          { url: '', caption: 'Bild 2' },
          { url: '', caption: 'Bild 3' },
        ],
      },
    },
    testimonials: {
      id: 'testimonials',
      type: 'testimonials',
      name: 'Testimonials',
      enabled: true,
      data: {
        title: 'Das sagen unsere Kunden',
        items: [
          {
            quote: 'Die kompetente Beratung hat mir sehr geholfen. Ich kann die Firma w\u00e4rmstens weiterempfehlen.',
            author: 'Hans P.',
            role: 'Zufriedener Kunde',
          },
        ],
      },
    },
    faq: {
      id: 'faq',
      type: 'faq',
      name: 'FAQ',
      enabled: false,
      data: {
        title: 'H\u00e4ufige Fragen',
        subtitle: 'Antworten auf die wichtigsten Fragen',
        items: [
          {
            question: 'Wie l\u00e4uft eine Erstberatung ab?',
            answer: 'In einem kostenlosen Erstgespr\u00e4ch lernen wir uns kennen und besprechen Ihre Situation.',
          },
          {
            question: 'Was kostet Ihre Dienstleistung?',
            answer: 'Die Kosten richten sich nach dem Umfang. Gerne erstellen wir Ihnen eine unverbindliche Offerte.',
          },
        ],
      },
    },
    authority: {
      id: 'authority',
      type: 'authority',
      name: 'Authority Strip',
      enabled: false,
      data: {
        title: 'Worauf Sie sich verlassen k\u00f6nnen',
        items: [
          { icon: '\u{1F3DB}\uFE0F', text: 'Eidg. dipl. / zertifiziert (Beispiel)' },
          { icon: '\u{1F9FE}', text: 'Unabh\u00e4ngig & neutral \u2013 keine Provisionen im Fokus' },
          { icon: '\u{1F512}', text: 'Datenschutz garantiert' },
        ],
        variant: 'chips',
      },
    },
    process: {
      id: 'process',
      type: 'process',
      name: 'Ablauf',
      enabled: false,
      data: {
        title: 'Ein Prozess, der Klarheit schafft',
        subtitle: 'Einfach, strukturiert, ohne Druck \u2013 mit messbaren Ergebnissen.',
        steps: [
          { num: '01', title: 'Erstgespr\u00e4ch', text: 'Ziele, Priorit\u00e4ten, n\u00e4chster Schritt \u2013 kurz und konkret.' },
          { num: '02', title: 'Analyse', text: 'Wir pr\u00fcfen Unterlagen, Optionen, Risiken und Einsparpotenzial.' },
          { num: '03', title: 'Empfehlung', text: 'Verst\u00e4ndliche Optionen mit Vor- und Nachteilen \u2013 ohne Fachjargon.' },
          { num: '04', title: 'Umsetzung', text: 'Wenn gew\u00fcnscht: saubere Dokumentation und Begleitung.' },
        ],
      },
    },
    proofTable: {
      id: 'proofTable',
      type: 'proofTable',
      name: 'Proof Table',
      enabled: false,
      data: {
        title: 'Vergleiche Qualit\u00e4t, nicht Marketing',
        subtitle: 'Eine klare Vergleichstabelle macht Differenzierung messbar.',
        headers: ['Kriterium', 'Wir', 'Andere'],
        rows: [
          { criterion: 'Rohstoff deklariert', us: '\u2713 Ja', other: '\u2717 Nein' },
          { criterion: 'Transparente Methode', us: '\u2713 Ja', other: 'Oft unklar' },
          { criterion: 'Schweizer Produktion', us: '\u2713 Ja', other: 'Meist Ausland' },
          { criterion: 'Ohne unn\u00f6tige Zus\u00e4tze', us: '\u2713 Ja', other: 'Oft enthalten' },
        ],
        highlightColumn: 1,
      },
    },
    stickyCta: {
      id: 'stickyCta',
      type: 'stickyCta',
      name: 'Sticky CTA',
      enabled: false,
      data: {
        text: 'Kostenloses Erstgespr\u00e4ch \u2013 in 15 Minuten zur Klarheit.',
        buttonText: 'Termin vereinbaren',
        phone: '078 000 00 00',
        note: 'Optional: Telefon direkt anrufen',
      },
    },
    cta: {
      id: 'cta',
      type: 'cta',
      name: 'Call to Action',
      enabled: true,
      data: {
        title: 'Bereit loszulegen?',
        subtitle: 'Kontaktieren Sie uns f\u00fcr ein unverbindliches Gespr\u00e4ch.',
        phone: '+41 31 XXX XX XX',
        email: 'info@example.ch',
      },
    },
    cookie: {
      id: 'cookie',
      type: 'cookie',
      name: 'Cookie Banner',
      enabled: true,
      data: {
        defaultMarketing: false,
        defaultStatistics: false,
        showSettingsButton: true,
        manageLinkText: 'Cookie-Einstellungen',
        preferencesText: 'W\u00e4hlen Sie aus, welche Cookies wir verwenden d\u00fcrfen. Notwendige Cookies sind immer aktiv.',
        preferencesTitle: 'Cookie-Einstellungen',
        marketingLabel: 'Marketing',
        statisticsLabel: 'Statistik',
        necessaryLabel: 'Notwendig',
        savePreferences: 'Speichern',
        openSettings: 'Einstellungen',
        acceptReject: 'Ablehnen',
        title: 'Cookie-Einstellungen',
        text: 'Wir verwenden Cookies, um Ihnen die bestm\u00f6gliche Erfahrung zu bieten.',
        acceptAll: 'Alle akzeptieren',
        acceptNecessary: 'Nur notwendige',
        policyLink: 'datenschutz.html',
      },
    },
    footer: {
      id: 'footer',
      type: 'footer',
      name: 'Footer',
      enabled: true,
      data: {
        companyName: 'Firmenname GmbH',
        tagline: 'Ihr Partner f\u00fcr XYZ in der Region.',
        address: 'Musterstrasse 123, 3000 Bern',
        phone: '+41 31 XXX XX XX',
        email: 'info@example.ch',
        linkedin: '',
        facebook: '',
        instagram: '',
      },
    },
  };
}

export const defaultSettings = {
  // Site Info
  siteName: 'Meine Website',
  siteDescription: 'Professionelle Dienstleistungen f\u00fcr Ihr Unternehmen.',

  // Colors
  primaryColor: '#134e4a',
  accentColor: '#d97706',

  // Color Stack Generator
  colorStack: null as any,
  useColorStack: false,

  // Appearance
  darkMode: false,
  darkModeToggle: false,
  fontStack: 'system',
  buttonStyle: 'filled' as 'filled' | 'outline' | 'soft',
  borderRadius: 'rounded' as 'none' | 'rounded' | 'pill',
  buttonRadius: 'rounded' as 'none' | 'rounded' | 'pill',

  // Elite Design
  stylePreset: 'signature',
  designDensity: 'balanced' as 'compact' | 'balanced' | 'airy',

  // Premium FX
  fxOrbs: false,
  fxGrain: false,
  fxGlass: false,
  fxIntensity: 'medium' as 'subtle' | 'medium' | 'intense',

  // Tracking & Datenschutz (CH)
  trackingPreset: 'none' as 'none' | 'ga4' | 'matomo',
  tracking: {
    ga4MeasurementId: '',
    matomoUrl: '',
    matomoSiteId: '',
  },

  // Favicon
  faviconEmoji: '\u{1F3E2}',

  // Multi-Page (Impressum & Datenschutz sind in CH Pflicht → default true)
  generateImpressum: true,
  generateDatenschutz: true,
  generateAgb: false,

  // AGB Settings
  agb: {
    gerichtsstand: 'Bern',
    zahlungsfrist: '30 Tage',
  },

  // Content Pages
  generateAngebot: false,
  generateMethoden: false,
  generateUeberMich: false,

  // Angebot Page Data
  pageAngebot: {
    sections: { hero: true, packages: true, cta: true },
    heroTitle: 'Unsere Angebote',
    heroSubtitle: 'Transparente Pakete, die zu Ihrem Bedarf passen.',
    packages: [
      {
        name: 'Basis',
        price: 'ab CHF 150/Mt.',
        description: 'F\u00fcr Einzelunternehmen und Kleinbetriebe.',
        features: 'Buchhaltung, MWST-Abrechnung, Jahresabschluss',
        highlighted: false,
        ctaText: 'Anfragen',
      },
      {
        name: 'Professional',
        price: 'ab CHF 350/Mt.',
        description: 'F\u00fcr wachsende KMU mit mehreren Mitarbeitenden.',
        features:
          'Alles aus Basis, Lohnbuchhaltung, Steuerberatung, Quartals-Reporting',
        highlighted: true,
        ctaText: 'Anfragen',
      },
      {
        name: 'Enterprise',
        price: 'Auf Anfrage',
        description: 'F\u00fcr anspruchsvolle Mandate mit individuellem Bedarf.',
        features:
          'Alles aus Professional, Konzernbuchhaltung, Revisionsbegleitung, CFO-Services',
        highlighted: false,
        ctaText: 'Gespr\u00e4ch vereinbaren',
      },
    ],
    ctaTitle: 'Nicht sicher, welches Paket passt?',
    ctaText:
      'Wir beraten Sie gerne pers\u00f6nlich und erstellen eine massgeschneiderte Offerte.',
    ctaButtonText: 'Unverbindlich anfragen',
  },

  // Methoden Page Data
  pageMethoden: {
    sections: { hero: true, intro: true, steps: true, tools: true, philosophy: true },
    heroTitle: 'Unsere Methodik',
    heroSubtitle: 'Wie wir arbeiten \u2014 strukturiert, transparent und nachvollziehbar.',
    introText:
      'Unser Ansatz verbindet bew\u00e4hrte Methoden mit modernen Tools. So erhalten Sie Ergebnisse, die Sie verstehen und nutzen k\u00f6nnen.',
    steps: [
      {
        title: 'Analyse & Verstehen',
        text: 'Wir beginnen mit einer gr\u00fcndlichen Analyse Ihrer Ausgangslage. Keine Annahmen, sondern Fakten.',
        icon: '\u{1F50D}',
      },
      {
        title: 'Strategie & Planung',
        text: 'Basierend auf der Analyse entwickeln wir einen klaren Plan mit messbaren Zielen und realistischen Meilensteinen.',
        icon: '\u{1F4CB}',
      },
      {
        title: 'Umsetzung & Begleitung',
        text: 'Wir setzen um \u2014 oder begleiten Sie bei der Umsetzung. Immer mit klarer Kommunikation und Dokumentation.',
        icon: '\u{1F6E0}\uFE0F',
      },
      {
        title: 'Kontrolle & Optimierung',
        text: 'Regelm\u00e4ssige Reviews stellen sicher, dass wir auf Kurs bleiben und Verbesserungen identifizieren.',
        icon: '\u{1F4CA}',
      },
    ],
    tools: [
      { name: 'Bexio', description: 'Buchhaltung & Rechnungswesen' },
      { name: 'KLARA', description: 'Lohn & Administration' },
      { name: 'Microsoft 365', description: 'Zusammenarbeit & Dokumente' },
    ],
    philosophyTitle: 'Unsere Philosophie',
    philosophyText:
      'Wir glauben an Transparenz, Einfachheit und Pragmatismus. Jede Methode muss dem Kunden dienen \u2014 nicht umgekehrt.',
  },

  // \u00dcber mich Page Data
  pageUeberMich: {
    sections: { hero: true, timeline: true, values: true, certifications: true },
    heroTitle: '\u00dcber mich',
    heroSubtitle: 'Die Geschichte hinter dem Unternehmen.',
    introText:
      'Mit \u00fcber 15 Jahren Erfahrung unterst\u00fctze ich Schweizer KMU dabei, ihre Finanzen im Griff zu haben \u2014 pragmatisch, verst\u00e4ndlich und digital.',
    imageUrl: '',
    timeline: [
      {
        year: '2008',
        title: 'Einstieg in die Treuhandbranche',
        text: 'Nach dem Studium begann mein Weg in einer renommierten Treuhandgesellschaft.',
      },
      {
        year: '2015',
        title: 'Spezialisierung auf KMU',
        text: 'Fokus auf die spezifischen Bed\u00fcrfnisse kleiner und mittlerer Unternehmen.',
      },
      {
        year: '2020',
        title: 'Gr\u00fcndung des eigenen Unternehmens',
        text: 'Der Schritt in die Selbstst\u00e4ndigkeit mit klarem Fokus auf digitale Treuhand.',
      },
    ],
    values: [
      { title: 'Transparenz', text: 'Keine versteckten Kosten, keine \u00dcberraschungen.' },
      { title: 'Pragmatismus', text: 'L\u00f6sungen, die im Alltag funktionieren.' },
      { title: 'Verl\u00e4sslichkeit', text: 'Termine und Zusagen werden eingehalten.' },
    ],
    certifications:
      'Eidg. dipl. Treuhandexperte, TREUHAND|SUISSE Mitglied, Zertifizierter Bexio-Partner',
  },

  // Legal Info (for Impressum)
  companyLegal: {
    name: 'Firmenname GmbH',
    owner: 'Max Muster',
    address: 'Musterstrasse 123, 3000 Bern',
    email: 'info@example.ch',
    phone: '+41 31 XXX XX XX',
    uid: 'CHE-123.456.789',
  },
};
